export interface GenerateExplorerLinkProps {
  conversationId: string;
  dashboardUrl: string;
  databaseId: string;
  iri?: string;
  model?: string;
  namedGraphs?: string[];
  reasoning?: boolean;
}

export const generateExplorerLink = ({
  conversationId,
  dashboardUrl,
  databaseId,
  iri,
  model,
  namedGraphs,
  reasoning,
}: GenerateExplorerLinkProps) => {
  const currentUrl = window.location.href;
  // check for a branch path in the url by looking for something between the app name and the #
  const match = currentUrl.match(
    /\/(?:designer|studio|explorer|knowledge-catalog)\/([^/]+)\/(?:index\.html)?#\//
  );

  const branchPath =
    match?.[1] && (match[1] === 'unstable' || currentUrl.includes('/explorer/'))
      ? `/${match[1]}`
      : '';

  const queryParams = [`db=${encodeURIComponent(databaseId)}`];

  if (namedGraphs) {
    queryParams.push(`graph=${encodeURIComponent(namedGraphs.join(','))}`);
  }

  if (model) {
    queryParams.push(`model=${encodeURIComponent(model)}`);
  }

  if (reasoning) {
    queryParams.push('reasoning');
  }
  if (iri) {
    const iriWithBackticks = `\`${iri}\``;
    queryParams.push(`query=${encodeURIComponent(iriWithBackticks)}`);
  }

  if (conversationId) {
    queryParams.push(`conversation=${encodeURIComponent(conversationId)}`);
  }

  const queryString = queryParams.join('&');
  const url = `${dashboardUrl}explorer${branchPath}/#/graph?${queryString}`;
  return url;
};
